/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpgradeCertificate
 */
export interface UpgradeCertificate {
    /**
     * 
     * @type {string}
     * @memberof UpgradeCertificate
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof UpgradeCertificate
     */
    userId?: string;
    /**
     * 
     * @type {string}
     * @memberof UpgradeCertificate
     */
    loyaltyAccountId?: string;
    /**
     * e.g. Marriott Bonvoy, World of Hyatt
     * @type {string}
     * @memberof UpgradeCertificate
     */
    programName?: string;
    /**
     * 
     * @type {string}
     * @memberof UpgradeCertificate
     */
    certificateType?: UpgradeCertificateCertificateTypeEnum;
    /**
     * Total certificates earned this period
     * @type {number}
     * @memberof UpgradeCertificate
     */
    totalCount?: number;
    /**
     * Certificates not yet applied
     * @type {number}
     * @memberof UpgradeCertificate
     */
    remainingCount?: number;
    /**
     * 
     * @type {Date}
     * @memberof UpgradeCertificate
     */
    earnedDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof UpgradeCertificate
     */
    expirationDate?: Date;
    /**
     * 
     * @type {number}
     * @memberof UpgradeCertificate
     */
    earningYear?: number;
    /**
     * How this certificate was created
     * @type {string}
     * @memberof UpgradeCertificate
     */
    source?: UpgradeCertificateSourceEnum;
    /**
     * User-provided notes (manual certificates only)
     * @type {string}
     * @memberof UpgradeCertificate
     */
    notes?: string | null;
    /**
     * Program-specific details
     * @type {object}
     * @memberof UpgradeCertificate
     */
    certificateMetadata?: object;
}


/**
 * @export
 */
export const UpgradeCertificateCertificateTypeEnum = {
    Nua: 'nua',
    Sua: 'sua',
    Cur: 'cur',
    IhgSuiteUpgrade: 'ihg_suite_upgrade'
} as const;
export type UpgradeCertificateCertificateTypeEnum = typeof UpgradeCertificateCertificateTypeEnum[keyof typeof UpgradeCertificateCertificateTypeEnum];

/**
 * @export
 */
export const UpgradeCertificateSourceEnum = {
    EmailParser: 'email_parser',
    ManualEntry: 'manual_entry'
} as const;
export type UpgradeCertificateSourceEnum = typeof UpgradeCertificateSourceEnum[keyof typeof UpgradeCertificateSourceEnum];


/**
 * Check if a given object implements the UpgradeCertificate interface.
 */
export function instanceOfUpgradeCertificate(value: object): value is UpgradeCertificate {
    return true;
}

export function UpgradeCertificateFromJSON(json: any): UpgradeCertificate {
    return UpgradeCertificateFromJSONTyped(json, false);
}

export function UpgradeCertificateFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpgradeCertificate {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'userId': json['user_id'] == null ? undefined : json['user_id'],
        'loyaltyAccountId': json['loyalty_account_id'] == null ? undefined : json['loyalty_account_id'],
        'programName': json['program_name'] == null ? undefined : json['program_name'],
        'certificateType': json['certificate_type'] == null ? undefined : json['certificate_type'],
        'totalCount': json['total_count'] == null ? undefined : json['total_count'],
        'remainingCount': json['remaining_count'] == null ? undefined : json['remaining_count'],
        'earnedDate': json['earned_date'] == null ? undefined : (new Date(json['earned_date'])),
        'expirationDate': json['expiration_date'] == null ? undefined : (new Date(json['expiration_date'])),
        'earningYear': json['earning_year'] == null ? undefined : json['earning_year'],
        'source': json['source'] == null ? undefined : json['source'],
        'notes': json['notes'] == null ? undefined : json['notes'],
        'certificateMetadata': json['certificate_metadata'] == null ? undefined : json['certificate_metadata'],
    };
}

export function UpgradeCertificateToJSON(json: any): UpgradeCertificate {
    return UpgradeCertificateToJSONTyped(json, false);
}

export function UpgradeCertificateToJSONTyped(value?: UpgradeCertificate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'user_id': value['userId'],
        'loyalty_account_id': value['loyaltyAccountId'],
        'program_name': value['programName'],
        'certificate_type': value['certificateType'],
        'total_count': value['totalCount'],
        'remaining_count': value['remainingCount'],
        'earned_date': value['earnedDate'] == null ? value['earnedDate'] : value['earnedDate'].toISOString().substring(0,10),
        'expiration_date': value['expirationDate'] == null ? value['expirationDate'] : value['expirationDate'].toISOString().substring(0,10),
        'earning_year': value['earningYear'],
        'source': value['source'],
        'notes': value['notes'],
        'certificate_metadata': value['certificateMetadata'],
    };
}

